import { Text } from "@/components/Primitives/Text"
import { useConfig } from "@/hooks/useConfig"
import { cn, formatFieldErrors } from "@/lib/utils/utils"
import { Icon } from "@/components/Primitives/Icon"
import { AlertTriangle } from "lucide-react"

interface FieldError {
  [key: string]: string | undefined
}

interface FormErrorDisplayProps {
  fieldErrors: FieldError
  fieldLabels: Record<string, string>
  className?: string
}

export function FormErrorDisplay({
  fieldErrors,
  fieldLabels,
  className,
}: FormErrorDisplayProps) {
  const { t } = useConfig()
  const formattedFields = formatFieldErrors(fieldErrors, fieldLabels)

  if (!formattedFields) {
    return null
  }

  return (
    <div
      className={cn(
        "p-4 bg-destructive rounded-xl flex items-center gap-4",
        className,
      )}
    >
      <div className="rounded-full bg-orange-800 p-2">
        <Icon
          className="text-destructive-foreground"
          size="sm"
          icon={AlertTriangle}
        />
      </div>
      <Text variant="small" className="text-destructive-foreground">
        {t("config_form_error_summary_instruction")}
      </Text>
    </div>
  )
}
